import { FC, useState } from 'react'
import { App, Button } from 'antd'
import { useHasAccess } from '../HasAccess'
import { Permission } from '../../utils/permissions'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { triggerUsersExport } from '../../services/UserService'
import { DEFAULT_ERROR } from '../../App'

type Props = {}

const UserExportUsers: FC<Props> = ({}) => {
  const { message } = App.useApp()
  const { hasAccess } = useHasAccess()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  if (!hasAccess(Permission.createAdmin)) {
    return <></>
  }

  const onClick = () => {
    setIsLoading(true)
    triggerUsersExport()
      .then(() => {
        message.success(
          'Users export successfully queued! You will receive it by email once available.'
        )
      })
      .catch(() => {
        message.error(DEFAULT_ERROR)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Button
      type="primary"
      onClick={onClick}
      loading={isLoading}
      icon={<CloudDownloadOutlined />}
    >
      Export to csv
    </Button>
  )
}

type UserExportUsersType = { ExportUsers: typeof UserExportUsers }

export { UserExportUsers, type UserExportUsersType }
